<mat-card class="fitContent">
    <mat-card-title>{{sharepointFile.filename}}</mat-card-title>
    <mat-card-content>
        <a mat-button color="primary" [href]="sharepointFile.url" target="_blank">Descargar <mat-icon>download</mat-icon></a>
    </mat-card-content>
</mat-card>
